import * as Sentry from '@sentry/vue';
import { getEnvVar } from '@/utils/env';

const tracesSampleRate = parseFloat(getEnvVar('VITE_SENTRY_TRACES_SAMPLE_RATE') ?? '0.0');

export function logError(err: Error, ...params: any[]) {
  if (tracesSampleRate) {
    Sentry.captureException(buildError(err, ...params));
  } else {
    /* eslint-disable-next-line no-console */
    console.error(buildError(err, ...params));
  }
}

const buildError = (err: Error, ...params: any[]): Error => {
  const paramStr = params?.length ? buildParams(...params) : 'no params';
  const message = err?.message ? err.message + ' - ' + paramStr : err.name + ' - ' + paramStr;

  return new Error(message, { cause: err });
};

const buildParams = (...params: any[]): string => {
  let paramStr = '';
  params.forEach((param, index) => {
    if (index) {
      paramStr += ' - ';
    }
    paramStr += 'info' + (index + 1) + ': ' + sanitizeParam(param);
  });

  return paramStr;
};

const sanitizeParam = (param: any): any => {
  try {
    if (typeof param === 'string' && param.length && param.length < 8193) {
      const oParam = JSON.parse(param);
      sanitize(oParam);
      return JSON.stringify(oParam);
    }

    if (typeof param === 'object') {
      sanitize(param);
      return JSON.stringify(param);
    }
  } catch (error) {
    // on error do nothing
  }

  return param;
};

const sanitize = (oParam: object): void => {
  sanitizeField(oParam, 'user');
  sanitizeField(oParam, 'username');
  sanitizeField(oParam, 'email');
  sanitizeField(oParam, 'password');
  sanitizeField(oParam, 'gName');
  sanitizeField(oParam, 'gContact');
};

const sanitizeField = (oParam: object, field: string): void => {
  if (oParam[field]) {
    switch (field) {
      case 'email':
        oParam[field] = maskEmail(oParam[field]);
        break;
      case 'password':
        oParam[field] = '***';
        break;
      default:
        oParam[field] = staredData(oParam[field]);
    }
  }
};

const maskEmail = (email: string) => {
  const atIndex = email.lastIndexOf('@');
  if (atIndex > -1) {
    return staredData(email.substring(0, atIndex)) + email.substring(atIndex);
  }
  return staredData(email);
};

const staredData = (data: string) => {
  if (data.length > 4) {
    return data.substring(0, 2) + '****' + data.substring(data.length - 2);
  }
  return '****';
};
